<template>
    <div class="card card-height">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Patient Name</th>
                        <th>Patient ID</th>
                        <th>Mobile No</th>
                        <th>Consultant Name</th>
                        <th v-if="isDoctor">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in bills" :key="i">
                        <td> {{ item.start_date_time }}</td>
                        <td> {{ item.contact_profile ? item.contact_profile.full_name : ''}}</td>
                        <td> {{ item.contact_profile ? item.contact_profile.serial_no : ''}}</td>
                        <td> {{ item.contact_profile ? item.contact_profile.mobile_no : ''}}</td>
                        <td> {{ item.service_resource ? item.service_resource.name : ''}}</td>
                        <td v-if="isDoctor">
                            <button
                                @click="onClickToEdit(item)"
                                class="btn btn-sm btn-primary mr-1"
                                title="Edit Appointment"
                            >
                                <i class="fas fa-pencil-alt"></i>
                            </button>
                            <button
                                @click="onClickToCancel(item)"
                                class="btn btn-outline-danger btn-sm mx-1"
                                title="Cancel Appointment"
                            >
                                <i class="far fa-times-circle"></i>
                            </button>
                            <button @click="onClickToOpenService(item)" class="btn btn-secondary btn-sm">
                                <i class="fas fa-tooth"></i>
                                Dental Service
                            </button>
                        </td>
                    </tr>

                </tbody>
            </table>
            <p v-if="!bills.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script setup>
import cloneDeep from "lodash/cloneDeep";
import { computed } from "vue";
import {useRoute, useRouter} from "vue-router";
import { useStore } from "vuex";

const props = defineProps({
    bills: Array
})

const emit = defineEmits(['onEdit', 'onCancel']);

const route = useRoute();
const router = useRouter();
const store = useStore();

const isDoctor = computed(() => store.getters['user/isDoctor']);

const onClickToOpenService = (item) => {
    router.push({
        name: 'dental-service',
        params: {
            ...route.params,
            serviceId: item.id
        },
        query: {
            ...cloneDeep(route.query),
            back_url: encodeURIComponent(route.fullPath)
        }
    })
}

const onClickToEdit = (item) => {
    if (!item) return;
    emit('onEdit', item);
}

const onClickToCancel = (item) => {
    if (!item) return;
    if (!confirm('Are you sure you want to cancel this appointment?')) return;
    emit('onCancel', item);
}
</script>
<style scoped>
.card--height {
  min-height: 200px
}
</style>
